<template>
    <v-container fluid :style="{'background-color':$store.getters.getColorPalette().backgroundColorCode}"> 
        <v-row no-gutters dense>
            <v-spacer></v-spacer>
            <v-col cols="1" align="center">
                <v-btn
                small
                fab
                :dark="$store.getters.getColorPalette().isDark"
                @click="addDialog = !addDialog"
                color="blue"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </v-col>
        </v-row>
        <v-row v-if="addDialog">
            <v-col cols="12">
                <AddPourQuantity />
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <PourQtyTable />
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
// import CalculatedParamTable from '@/components/lists/derived/CalculatedParamTable'
import AddPourQuantity from '@/components/crud_components/manufacturing/AddPourQuantity';
import PourQtyTable from '@/components/lists/manufacturing/PourQtyTable';
export default {
    name:'RawMaterialsPage',
    components:{
        // CalculatedParamTable,
        AddPourQuantity,
        PourQtyTable,
    },
    data(){
        return {
            addDialog:false,
        }
    }
}
</script>